module.exports = __webpack_public_path__ + "models/71ce6966203ac33a1d2330cbad1e3997.glb";